import React from "react";

import { Button, ToggleSwitch } from "shared/ui";

import { useIikoIntegrationContext } from "features/IikoIntegration/context";

import { Action, Card, Description, Divider, Events, Row, Text, Title } from "./styles";

/*
* У одного ключа iiko только один адрес уведомлений, поэтому «занято чужим адресом» —
* отдельное состояние: подключение перебьёт чужую интеграцию, и об этом надо предупредить.
* */
export const WebhookCard = () => {
    const state = useIikoIntegrationContext();

    const saving = state.saving.webhook;
    const webhook = state.webhook;
    const isConnected = webhook?.isConnected === true;
    const foreignUri = !isConnected ? webhook?.registeredUri : null;

    const dirty = state.webhookEventsDirty;

    const buttonLabel = () => {
        if (saving) return "Сохраняем…";
        if (dirty) return "Применить";

        return isConnected ? "Переподключить" : "Подключить";
    };

    const description = () => {
        if (dirty) return "Изменения ещё не применены — нажмите «Применить»";
        if (!state.webhookChecked) return "Проверяем настройки уведомлений в iiko…";
        if (isConnected) return "События приходят из iiko автоматически";

        if (foreignUri) {
            return `У этого ключа iiko уже прописан другой адрес: ${foreignUri}. ` +
                "Подключение заменит его — если ключом пользуется другая интеграция, ей перестанут приходить события.";
        }

        return "Пока не подключены: стоп-листы не обновляются, а статусы заказов из iiko не приходят";
    };

    return (
        <Card>
            <Row>
                <Text>
                    <Title>Уведомления из iiko</Title>
                    <Description>{description()}</Description>
                </Text>

                <Action>
                    <Button
                        variant={isConnected && !dirty ? "outlined" : "contained"}
                        color={isConnected && !dirty ? "neutral" : undefined}
                        disabled={saving}
                        onClick={state.connectWebhook}
                    >
                        {buttonLabel()}
                    </Button>
                </Action>
            </Row>

            {state.webhookChecked && (
                <>
                    <Divider />

                    <Events>
                        <ToggleSwitch
                            checked={state.webhookEvents.stopLists}
                            onChange={(value) => state.toggleWebhookEvent("stopLists", value)}
                            disabled={saving}
                            label="Стоп-листы"
                            hint="Блюдо, поставленное в стоп на кассе, пропадает у гостя"
                        />
                        <ToggleSwitch
                            checked={state.webhookEvents.tableOrders}
                            onChange={(value) => state.toggleWebhookEvent("tableOrders", value)}
                            disabled={saving}
                            label="Заказы в зал"
                            hint="Подтверждение, что заказ со столика принят на кассе"
                        />
                        <ToggleSwitch
                            checked={state.webhookEvents.deliveryOrders}
                            onChange={(value) => state.toggleWebhookEvent("deliveryOrders", value)}
                            disabled={saving}
                            label="Заказы на доставку и навынос"
                            hint="Подтверждение и отмена заказов, оформленных с доставкой или самовывозом"
                        />
                    </Events>
                </>
            )}
        </Card>
    );
};
